import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IDocumentTemplate, IDocumentUserTemplate } from "../models/document-id";

@Injectable({
  providedIn: "root",
})
export class TemplateDocumentService {
  public baseUrl: string = "/document-template";

  public list: IDocumentTemplate[] = [];

  public userTemplateList: IDocumentUserTemplate[] = [];

  public templateDocumentOnBoardingList: any = [];

  constructor(private _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get(this.baseUrl)
      .toPromise()
      .then((response: IDocumentTemplate[]) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  //Get di tutti i dipendenti, per ogni dipendente avrà una lita di template con lo stato inviato o non inviato
  async getUserTemplateList() {
    return this._httpClient
      .get(this.baseUrl + "/users")
      .toPromise()
      .then((response: IDocumentUserTemplate[]) => {
        this.userTemplateList = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  //Get per i documenti che l'utente deve visionare all'onBoarding
  async getTemplateDocumentOnBoarding(defRet: any = []): Promise<any> {
    return this._httpClient
      .get(this.baseUrl + "/onboarding")
      .toPromise()
      .then((response: any) => {
        if (!Array.isArray(response) && !!response.templates) {
          response = response.templates;
        }
        response = response.filter((doc: any) => doc.id !== null);
        this.templateDocumentOnBoardingList = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return defRet;
      });
  }

  async create(data: any = []) {
    return this._httpClient
      .post(this.baseUrl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: any = {}) {
    return this._httpClient.put(this.baseUrl + "/" + id, data).toPromise();
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseUrl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async getTemplate(id: number) {
    return this._httpClient.get(this.baseUrl + "/" + id).toPromise();
  }

  async upload_file_template(file: any, id: any) {
    return this._httpClient
      .post(`${this.baseUrl}/upload/${id}`, { file })
      .toPromise()
      .then(async (response) => {
        return response;
      })
      .catch((err: any) => {
        return console.error(err);
      });
  }

  async sendDocumentTemplate(data: { users: string[] }, id: string) {
    return this._httpClient
      .post(this.baseUrl + "/send/" + id, data)
      .toPromise()
      .then(async (response) => {
        return response;
      });
  }
}
